import {
  REQUEST_CHANGESTATUS_RESULTS,
  RECEIVE_CHANGESTATUS_RESULTS,
  ERROR_CHANGESTATUS_RESULTS,
} from 'typeConstants';
import { changeStatus as initialState } from '../initialState.tsx';

const changeStatus = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_CHANGESTATUS_RESULTS:
      return {
        ...state,
        processingStatusChange: true
      };

    case RECEIVE_CHANGESTATUS_RESULTS:
      return {
        ...state,
        processingStatusChange: false,

      };

    case ERROR_CHANGESTATUS_RESULTS:
      return {
        ...state,
        processingStatusChange: true
      };
    default:
      return state;
  }
};

export default changeStatus;
